<template>
  <div class="container">
    <el-card shadow="never">
    <h2>门店基础信息</h2>
    <el-divider/>
    <el-form-item
      label="总部商户编号"
      required>
       <!-- 编辑可以值可填写 -->
      <el-input class="form-input" v-if="form.auditStatus === -1"  v-model="form.chainHeadMerchantId" placeholder="总部商户编号" @blur="handleHeadShopMerchantIdBlur" @input="change()"></el-input>
      <el-input class="form-input" v-else :disabled="isEdit || (passed || businessEditable || readOnly) && !isUpgrade" v-model="form.chainHeadMerchantId" placeholder="总部商户编号" @blur="handleHeadShopMerchantIdBlur"></el-input>
    </el-form-item>
    <el-form-item label="门店信息" prop="profileFromHead" required>
      <!-- 编辑可以值可填写 -->
      <el-select filterable v-if="form.auditStatus === -1"  v-model="form.profileFromHead" @input="change()">
        <el-option label="与总部一致" :value="1" ></el-option>
        <el-option label="与总部不一致" :value="0" ></el-option>
      </el-select>
      <el-select filterable v-else v-model="form.profileFromHead" :disabled="isEdit || (passed || businessEditable || readOnly) && !isUpgrade" @input="change()">
        <el-option label="与总部一致" :value="1" ></el-option>
        <el-option label="与总部不一致" :value="0" ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="门店名称" prop="chainShopName" required>
      <el-input class="form-input" v-if="form.auditStatus === -1" v-model="form.chainShopName" placeholder="商户简称，2~30个字，不能为纯数字，不能包含敏感词汇" @input="change()"></el-input>
      <el-input class="form-input" v-else v-model="form.chainShopName" placeholder="商户简称，2~30个字，不能为纯数字，不能包含敏感词汇" :disabled="readOnly" @input="change()"></el-input>
    </el-form-item>
    <el-form-item label="门店类型" prop="chainBranchShopType" required>
      <el-select v-if="form.auditStatus === -1" v-model="form.chainBranchShopType" @input='change()'>
        <el-option :value="1" label="直营"></el-option>
        <el-option :value="2" label="加盟"></el-option>
        <el-option :value="3" label="联营"></el-option>
      </el-select>
      <el-select v-else v-model="form.chainBranchShopType" :disabled="readOnly" @input='change()'>
        <el-option :value="1" label="直营"></el-option>
        <el-option :value="2" label="加盟"></el-option>
        <el-option :value="3" label="联营"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="`门店性质`" prop="chainMerchantType" required>
      <el-select v-if="form.auditStatus === -1" v-model="form.chainMerchantType" @change="wxMchTypeChange"  @input="change()" >
        <el-option :value="1" label="小微商户" v-if="!isUpgrade "></el-option>
        <el-option :value="2" label="个体商户"></el-option>
        <el-option :value="3" label="企业商户" ></el-option>
        <el-option :value="4" label="事业单位" ></el-option>
        <el-option :value="5" label="其他组织" ></el-option>
      </el-select>
      <el-select v-else v-model="form.chainMerchantType" @change="wxMchTypeChange"  @input="change()" :disabled="isEdit || (passed || businessEditable || readOnly) && !isUpgrade">
        <el-option :value="1" label="小微商户" v-if="!isUpgrade "></el-option>
        <el-option :value="2" label="个体商户"></el-option>
        <el-option :value="3" label="企业商户" ></el-option>
        <el-option :value="4" label="事业单位" ></el-option>
        <el-option :value="5" label="其他组织" ></el-option>
      </el-select>
      <!-- <span @click.prevent="setUpgrade" v-if="canUpgrade" style="padding-left: 12px;">
        <el-radio v-model="isUpgrade" :label="true">升级</el-radio>
      </span> -->
    </el-form-item>
    <el-form-item label="所属品牌" prop="chainBrandId" required>
      <el-select v-if="form.auditStatus === -1" v-model="form.chainBrandId" @input='change()'>
        <el-option :value="item.brandId" :label="item.brandName" v-for="(item,index) in brandList" :key="index"></el-option>
      </el-select>
      <el-select v-else v-model="form.chainBrandId" :disabled="readOnly" @input='change()'>
        <el-option :value="item.brandId" :label="item.brandName" v-for="(item,index) in brandList" :key="index"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="行业类型" required>
      <!-- 编辑和查看不能编辑 -->

      <el-row type="flex">
        <el-form-item
          prop="chainMccGrandpaCode"
          class="form-flex-item"
          :rules="{
            required: !businessEditable,
            message: '请选择全部行业',
            trigger: 'blur'
          }">
          <el-select
            style="width:200px;"
            v-if="form.auditStatus === -1"
            placeholder="全部行业"
            clearable
            filterable
            v-model="form.chainMccGrandpaCode"
            @change="getGroup">
            <el-option v-for="item in mcc_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
          </el-select>
          <el-select
            style="width:200px;"
            :disabled="isEdit || (passed || businessEditable || readOnly) && !isUpgrade"
            placeholder="全部行业"
            v-else
            clearable
            filterable
            v-model="form.chainMccGrandpaCode"
            @change="getGroup">
            <el-option v-for="item in mcc_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="chainMccFatherCode"
          class="form-flex-item"
          :rules="{
            required: !businessEditable,
            message: '请选择行业小类',
            trigger: 'blur'
          }">
          <el-select
            style="width:200px;"
            v-if="form.auditStatus === -1"
            placeholder="行业小类"
            clearable
            filterable
            v-model="form.chainMccFatherCode"
            @change="getMccDetails">
            <el-option v-for="item in mccMiddle_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
          </el-select>
          <el-select
            v-else
            style="width:200px;"
            :disabled="isEdit || (passed || businessEditable || readOnly) && !isUpgrade"
            placeholder="行业小类"
            clearable
            filterable
            v-model="form.chainMccFatherCode"
            @change="getMccDetails">
            <el-option v-for="item in mccMiddle_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="chainMccCode"
          :rules="{
            required: !businessEditable,
            message: '请选择详细类别',
            trigger: 'blur'
          }">
          <el-select
            style="width:200px;"
            v-if="form.auditStatus === -1"
            placeholder="请选择详细类别"
            filterable
            clearable
            v-model="form.chainMccCode">
            <el-option
              v-for="item in group_list"
              :key="item.mccCode"
              :label="item.mccTxt"
              :value="item.mccCode" ></el-option>
          </el-select>
          <el-select
            v-else
            style="width:200px;"
            :disabled="isEdit || (passed || businessEditable || readOnly) && !isUpgrade"
            placeholder="请选择详细类别"
            filterable
            clearable
            v-model="form.chainMccCode">
            <el-option
              v-for="item in group_list"
              :key="item.mccCode"
              :label="item.mccTxt"
              :value="item.mccCode" ></el-option>
          </el-select>
        </el-form-item>
      </el-row>
    </el-form-item>
    <el-form-item label="客服电话" prop="chainServicePhone">
      <el-input class="form-input" v-if="form.auditStatus === -1" v-model="form.chainServicePhone" placeholder="用于联系商家客服，不填默认为商户账号信息填写手机号" @input='change()'></el-input>
      <el-input class="form-input" v-else v-model="form.chainServicePhone" placeholder="用于联系商家客服，不填默认为商户账号信息填写手机号" :disabled="readOnly" @input='change()'></el-input>
    </el-form-item>
    </el-card>
    <el-card shadow="never" v-if="readOnly || isEdit">
      <h2>联系人信息&nbsp;<auth-button opt="edit_contact" @click.native="toChangeContact" label="修改" v-if="isEdit"></auth-button></h2>
      <el-divider/>
        <div class="contactDiv">
          <div class="contactItem"><span class="contactLabel">联系人姓名</span>{{form.contactName ? form.contactName : '-'}}</div>
          <div class="contactItem"><span class="contactLabel">联系人身份证</span>{{form.contactIdCard ? form.contactIdCard : '-'}}</div>
          <div class="contactItem"><span class="contactLabel">联系人手机号</span>{{form.contactPhoneNo ? form.contactPhoneNo : '-'}}</div>
        </div>
      </el-card>
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px"
      title="修改联系人信息"
      @close="() => this.dialogVisible = false">
      <el-form
        label-width="120px"
        ref="contactInfo"
        label-position="left"
        :model="contactInfo"
        :rules="rule_data"
        :disabled="readOnly"
        class="contactForm">
        <el-form-item label="联系人姓名" prop="contactName">
          <el-input class="form-input" v-model="contactInfo.contactName" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系人身份证" prop="contactIdCard">
          <el-input class="form-input" v-model="contactInfo.contactIdCard" placeholder="请输入联系人身份证"></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="contactPhoneNo">
          <el-input class="form-input" v-model="contactInfo.contactPhoneNo" placeholder="请输入联系人手机号"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { checkMerchantId, checkUsername, updateContactInfo } from '@/api/merchant'
import { chainGroupBrandList } from '@/api/merchant-info'
import { hidePhoneNum } from '@/utils/hideSensitiveInfo.js'
import { getMcc } from '@/api/global'
import { agentMixins } from './agentMixins'
export default {
  components: {
  },
  mixins: [agentMixins],
  data () {
    return {
      headShopMerchantIdError: '', // 总店编号错误信息
      userNameItemError: '', // 登录账号错误信息
      checkLoading: false, // 登录账号校验加载
      mcc_list: [], // 行业大类列表
      mccMiddle_list: [], // 行业小类列表
      group_list: [], // 行业详细类列表
      headShopMerchantIdOld: '',
      dialogVisible: false,
      brandList: [],
      contactInfo: {
        contactName: '',
        contactIdCard: '',
        contactPhoneNo: ''
      }
    }
  },
  mounted () {
    this.getMcc(1, 0)// 获取行业类型
    console.log('isChain: ', this.isChain)
  },
  watch: {
    needMcc (val) {
      if (val) {
        this.resetMccGroup()
        this.chainGroupBrandList()
      }
    }
  },
  computed: {
    headShopMerchantIdInput () {
      return !(this.form.shopType === 1)
    },
    fAgentId () { return this.$store.getters.userId },
    ifHide () { return this.form.statusDesc === '审核通过' || this.form.statusDesc === '待审核' },
    businessEditable () { return this.form.businessInfoFlag === 1 }
  },
  methods: {
    change () {
      this.$forceUpdate() // 强制刷新
    },
    // 获取品牌
    async chainGroupBrandList () {
      try {
        if (!this.form.chainHeadMerchantId) return
        const res = await chainGroupBrandList({
          merchantId: this.form.chainHeadMerchantId
        })
        if (+res.error_code !== 0) return this.$message.error(res.error_msg)
        this.brandList = res.data.list
        console.log('品牌')
        console.log(res)
        // this.brandList = res.data.list
      } catch (e) {
        console.log(e)
      }
    },
    /**
             * @description 选中行业大类后获取行业小类列表
             * @param {Number} id 选中的大类id
             */
    getGroup (id) {
      if (id) {
        this.getMcc(2, id)
        this.form.chainMccFatherCode = ''
        this.form.chainMccCode = ''
      }
    },
    /**
             * @description 选中行业小类后获取行业详细类别列表
             * @param {Number} id 选中的小类id
             */
    getMccDetails (id) {
      if (id) {
        this.getMcc(3, id)
        this.form.chainMccCode = ''
      }
    },
    /**
             * @description 行业大类和小类的列表获取
             */
    getMcc (level, id) {
      let params = {
        level: level
      }
      let listKey = ''
      if (level === 3 && id !== 0) {
        params.fatherCode = id
        this.form.chainMccCode = ''
        listKey = 'group_list'
      } else if (level === 2 && id !== 0) {
        params.fatherCode = id
        this.form.chainMccFatherCode = ''
        listKey = 'mccMiddle_list'
      } else {
        listKey = 'mcc_list'
      }
      this[listKey] = []
      params = qs.stringify(params)
      getMcc(params).then(data => {
        if (data.result_cde === '0') {
          this[listKey] = data.data
        }
      })
    },
    /**
         * @description 加载本地数据之后获取行业列表
         */
    resetMccGroup () {
      const chainMccFatherCode = this.form.chainMccFatherCode
      const chainMccCode = this.form.chainMccCode

      this.getGroup(this.form.chainMccGrandpaCode)
      this.form.chainMccFatherCode = chainMccFatherCode
      this.getMccDetails(this.form.chainMccFatherCode)
      this.form.chainMccCode = chainMccCode
    },
    /**
     * @description 检测账号的可用性
     */
    checkUserName () {
      let userName = this.form.username
      if (userName === '') {
        this.$message({
          message: '请输入登录账号.'
        })
        return false
      }
      userName = qs.stringify({ userName: userName })
      this.checkLoading = true
      this.userNameItemError = ''
      checkUsername(userName).then(data => {
        this.checkLoading = false
        if (data.error_code === '0') {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.userNameItemError = data.error_msg
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    getNewMobile (value) {
      this.form.mobile = this.ifHide ? hidePhoneNum(value) : value || ''
    },
    handleViewAccount (account) {
      this.form.username = account.fUserName
      this.form.mobile = account.fMobile
      this.businessForm.legalName = account.fApplicant
      this.form.servicePhone = account.fServicePhone
      this.settleForm.holder = account.fBankHolder
      this.settleForm.bankCardNo = account.fBankAccount
    },
    /**
     * @description 切换店铺类型
     * @param {Number} value 0分店，1总店
     */
    changeShopType (value) {
      // 总店，清空内容
      if (value === 1) {
        this.form.chainHeadMerchantId = ''
        this.settleForm.settleTo = ''
        this.form.merchantType = ''
        this.form.realMerchantType = ''
        this.form.merchantShortName = ''
        this.form.mccCode = ''
        this.form.mccMiddle = ''
        this.form.mccType = ''
        this.form.businessInfoFlag = ''
        this.businessInfoMethod(0)
        this.$parent.$parent.$refs.settleForm.resetFields()
        this.$parent.$parent.$refs.settleInfo.$refs.bankBranchForm.$refs.form.clearValidate()
        this.$parent.$parent.$refs.basicForm.clearValidate()
      }
    },
    /**
     * @description 总商户编号输入框获取焦点事件
     */
    handleHeadShopMerchantIdBlur () {
      const data = qs.stringify({ FMerchantId: this.form.chainHeadMerchantId })
      this.headShopMerchantIdError = ''
      // 查询总店编号是否有误
      checkMerchantId(data).then(response => {
        // 如果总店编号存在
        if (response.error_code === '0') {
          this.chainGroupBrandList()
          this.$message({
            message: response.error_msg,
            type: 'success'
          })
          // 如果总店商户id修改过，重置商户入网信息
          if (this.headShopMerchantIdOld !== this.form.chainHeadMerchantId) {
            // 如果企业资料选的是总店，先清空内容
            if (this.form.businessInfoFlag === 1) {
              this.businessInfoMethod(0)
            }
            // 如果结算对象是总店且是进件加盟分店，清空内容
            if (this.settleForm.settleTo === 1 && this.headShopMerchantIdInput) {
              this.settleForm.settleTo = ''
              this.settleToMethod(this.settleForm.settleTo)
            }
            this.form.headMerchantId = this.form.chainHeadMerchantId
            //    查询总店的数据，如果企业资料和结算信息选择总店就可以直接回填
            this.getParentData()
          }
        } else {
          this.headShopMerchantIdError = response.error_msg
          this.$message({
            message: response.error_msg,
            type: 'warning'
          })
        }
        // 保存原来的总店商户id
        this.headShopMerchantIdOld = this.form.chainHeadMerchantId
      })
    },
    wxMchTypeChange (value) {
      if (value > 2 && this.form.merchantType === 3) {
        this.form.merchantType = 3
        this.form.companyChildType = value - 2
        return
      }
      if (value === 1) {
        this.businessForm.licenseFlag = true
        this.resetLicense()
        this.businessForm.credentialType = 1
        this.settleForm.accountType = 1
        this.settleForm.legalFlag = 1
        this.settleForm.holder = this.businessForm.legalName
        this.settleForm.bankIdCardType = this.businessForm.credentialType
        this.settleForm.accountIdCardNo = this.businessForm.idCardNo
        this.form.merchantType = 1
        this.form.companyChildType = ''
      } else {
        this.businessForm.licenseFlag = false
        this.settleForm.accountType = ''
        this.settleForm.legalFlag = ''
        this.businessForm.merchantName = ''
        if (value >= 3) {
          this.form.merchantType = 3
          this.form.companyChildType = value - 2
        } else {
          this.form.merchantType = 2
        }
      }
    },
    // changeBusinessInfo (value) {
    //   this.businessInfoMethod(value)
    //   if (value === 1) {
    //     this.resetMccGroup()
    //   }
    // },
    toChangeContact () {
      this.contactInfo.contactName = this.form.contactName
      this.contactInfo.contactIdCard = this.form.contactIdCard
      this.contactInfo.contactPhoneNo = this.form.contactPhoneNo
      this.dialogVisible = true
    },
    editContact () {
      const params = qs.stringify(this.contactInfo)
      this.$refs.contactInfo.validate(valid => {
        if (valid) {
          updateContactInfo(params).then(response => {
            if (response.error_code === '0') {
              this.dialogVisible = false
              this.form.contactName = this.contactInfo.contactName
              this.form.contactIdCard = this.contactInfo.contactIdCard
              this.form.contactPhoneNo = this.contactInfo.contactPhoneNo
            } else {
              this.$message({
                type: 'error',
                showClose: true,
                message: response.error_msg
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.block-type{
  margin:0 10px 0 0;
}
  .red label{
    color: red;
  }
  .form-input {
    width: 450px;
  }
  .contactForm .form-input {
    width: 300px;
  }
  .form-flex-item {
    margin-right: 5px;
  }
  .form-tip-label {
    margin: 0;
    color:#D49B5F;
    vertical-align:middle;
    display:inline-block;
    font-size:14px;
    font-family:Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  }
  .file-download-button {
    color: #409eff;
    margin: 0 10px;
  }
  .report-config-id-tip-view {
    margin: 10px 100px;
    color: #606266;
    font-size: 14px;
  }
  @mixin flex-horizontal {
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .is-participate-view {
    @include flex-horizontal;
    margin-bottom: 10px;
    .is-participate-view-title {
      margin-right: 30px;
    }
  }
  .report-config-id-tip-view {
    margin: 10px 100px;
    color: #606266;
    font-size: 14px;
  }
  .merchant-info-head-view {
    @include flex-horizontal;
    justify-content: space-between;
    .merchant-info-title-view {
      flex: 1;
    }
    .merchant-info-batch-import-view {
      .merchant-info-batch-import-buttons {
        @include flex-horizontal;
      }
      .new-file-tip {
        font-size: 14px;
        margin: 5px 0;
      }
      .new-file-name {
        font-size: 14px;
      }
    }
  }
  .submitBtn{
      display: block;
      margin: 20px auto;
  }
  p.form-tip-label{
    display: block;
  }
  .contactItem:last-child {
    margin-bottom: 0;
  }
  .contactItem {
    font-size: 14px;
    color: #606266;
    line-height: 40px;
  }
  .contactLabel {
    width: 120px;
    display: inline-block;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
</style>
